import { NavLink } from "../interfaces/nav-link.interface";

export const NAV_LINKS = [
  { label: 'headerComponent.howItWorks', fragment: 'how-it-works' },
  { label: 'headerComponent.plans', fragment: 'plans' },
];

export const NAV_LINKS_HOME:NavLink[] = [
  { label: 'homeSidebar.home', path: '/main/home', name: 'home' },
  { label: 'homeSidebar.inventory', path: '/main/inventory', name: 'inventory' },
  { label: 'homeSidebar.customers', path: '/main/customers', name: 'customers' },
  { label: 'homeSidebar.orders', path: '/main/orders', name: 'orders' },
  { label: 'homeSidebar.staff', path: '/main/staff', name: 'staff' },
  { label: 'homeSidebar.brands', path: '/main/brands', name: 'brands' },
];

export const NAV_LINKS_HOME_SADMIN: NavLink[] = [
  { label: 'homeSidebar.home', path: '/main/home', name: 'home' },
  { label: 'homeSidebar.shops', path: '/main/shop', name: 'shops' },
  { label: 'homeSidebar.admins', path: '/main/admins', name: 'admins' },
  { label: 'homeSidebar.payments', path: '/main/payments', name: 'payments' },
  { label: 'homeSidebar.content', path: '/main/content', name: 'content' },
];

export const INVENTORY_LINKS = [
  { label: 'inventory.ItemLists', path: '/main/inventory/items', name: 'items' },
];
